import React, { useEffect } from 'react';
import { useAtom } from "jotai";
import OrderList from './OrderList';
import { fireGoogleAnalyticsTag } from '../analytics/googleAnalytics';
import messageMap from './i18n/messageMap.json';
import { customerAtom } from "./atoms";


const SuccessPage = () => {
    const [customer] = useAtom(customerAtom);
    const { emailAddress, confirmationNumber } = customer;

    useEffect(() => {
        // Scroll to the top when this component is rendered
        window.scrollTo(0, 0);

        // Fire GA event to track # of sessions for this page
        fireGoogleAnalyticsTag({
            category: 'Passover Menu',
            action: 'Success Page View',
            addDevice: true
        });
    }, []);

    return (
        <div id="success" className="passover-menu-page">
            <div className="message-section">
                <h2 className="sub-title message">
                    <span className="fa-stack fa-lg">
                        <i className="fa fa-circle fa-stack-1x" aria-hidden="true"></i>
                        <i className="fa fa-check-circle fa-stack-1x success-check" aria-hidden="true"></i>
                    </span>
                    Thank You!
                </h2>
                <h3 className="success-subtitle message">Your order has been placed successfully!</h3>
                { (emailAddress) ? <h3 className="success-subtitle message">We have sent you an email summary of your order</h3> : "" }
            </div>
            <div className="order-information-section">
                <p><span className="field-name message">Confirmation #</span>: {confirmationNumber}</p>
            </div>
            <OrderList />
            <h4 className="pickup-date-reminder">{messageMap.orderPickupDate}</h4>
            <div className="contact-info-section">
                <h4 className="contact-info-section-title">Questions? <a href="/contact-us" className="with-underline">Contact Us</a></h4>
                <ul className="contact-info-methods">
                    <li className="contact-info-method">
                        <i className="fa fa-phone fa-1x contact-info-method-icon"></i>
                        516-678-6161
                    </li>
                    <li className="contact-info-method">
                        <i className="fa fa-envelope fa-1x contact-info-method-icon"></i>
                        <a href="mailto:party@kombertcaterers.com" className="with-underline">party@kombertcaterers.com</a>
                    </li>
                    <li className="contact-info-method">
                        <i className="fa fa-map-marker fa-1x contact-info-method-icon"></i>
                        Directions
                    </li>
                    <li className="contact-info-method">
                        <span className="contact-info-method-icon facebook"></span>
                        <a href="https://www.facebook.com/Kombert-Caterers-125111774249639/" target="_blank" className="with-underline">Like us on Facebook</a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default SuccessPage;
